import { EpimsBankDetailDto } from './../../../../../data/src/lib/dto/epimsbank-detail.dto';
import { Component, OnInit } from '@angular/core';
import { CountryFacade } from '../../states/+country/country.facade';
import { Observable, Subscription } from 'rxjs';
import {
  CountryDto,
  StateDto,
  LgaDto,
  ScholarshipTypeDto,
  ScholarshipCategoryDto,
  ScholarshipSessionDto,
  ScholarshipAwardDurationDto,
  CommunityDto,
  CourseOfStudyDto,
  EpimsGenderDto,
  EpimsBankDto,
  CurrencyDto,
} from '@cradua/data';
import { StateFacade } from '../../states/+state/state.facade';
import { LgaFacade } from '../../states/+lga/lga.facade';
import { ScholarshipTypeFacade } from '../../states/+scholarshiptype/scholarshiptype.facade';
import { ScholarshipCategoryFacade } from '../../states/+scholarshipcategory/scholarshipcategory.facade';
import { ScholarshipSessionFacade } from '../../states/+scholarshipsession/scholarshipsession.facade';
import { ScholarshipAwardDurationFacade } from '../../states/+scholarshipawardduration/scholarshipawardduration.facade';
import { CommunityFacade } from '../../states/+community/community.facade';
import { CourseOfStudyFacade } from '../../states/+courseofstudy/courseofstudy.facade';
import { GenderFacade } from '../../states/+gender/gender.facade';
import { MatDialogConfig } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { EpimsBankFacade } from '../../states/+bank/bank.facade';
import { EpimsBankDetailFacade } from '../../states/+bankDetail/bank-detail.facade';
import { CurrencyFacade } from '../../states/+currency/currency.facade';

@Component({
  selector: 'mrsoftapps-reference-container',
  templateUrl: './reference-container.component.html',
  styleUrls: ['./reference-container.component.scss'],
})
export class ReferenceContainerComponent implements OnInit {
  isLoadingCountry$: Observable<any>;
  isLoadingState$: Observable<any>;
  isLoadingLga$: Observable<any>;
  isLoadingScholarshipType$: Observable<any>;
  isLoadingScholarshipCategory$: Observable<any>;
  isLoadingScholarshipSession$: Observable<any>;
  isLoadingScholarshipAwardDuration$: Observable<any>;
  isLoadingCommunity$: Observable<any>;
  isLoadingCourseOfStudy$: Observable<any>;
  isLoadingGender$: Observable<any>;
  isLoadingBank$: Observable<any>;
  isLoadingBankDetail$: Observable<any>;
  isLoadingCurrency$: Observable<any>;

  countries: any[];
  states: any[];
  lgas: any[];
  scholarshipTypes: any[];
  scholarshipCategories: any[];
  scholarshipSessions: any[];
  scholarshipAwardDurations: any[];
  courseOfStudies: any[];
  communities: any[];
  genders: any[];
  banks: any[];
  bankDetails: any[];
  currencies: any[];

  country$: Observable<CountryDto[]>;
  state$: Observable<StateDto[]>;
  lga$: Observable<LgaDto[]>;
  scholarshipType$: Observable<ScholarshipTypeDto[]>;
  scholarshipCategory$: Observable<ScholarshipCategoryDto[]>;
  scholarshipSession$: Observable<ScholarshipSessionDto[]>;
  scholarshipAwardDuration$: Observable<ScholarshipAwardDurationDto[]>;
  community$: Observable<CommunityDto[]>;
  courseOfStudy$: Observable<CourseOfStudyDto[]>;
  gender$: Observable<EpimsGenderDto[]>;
  bank$: Observable<EpimsBankDto[]>;
  bankDetail$: Observable<EpimsBankDetailDto[]>;
  currency$: Observable<CurrencyDto[]>;

  data;
  task = 'load';
  sub: Subscription;
  items = [
    { id: 'scholarshipCategory', name: 'Scholarship Category' },
    { id: 'scholarshipType', name: 'Scholarship Type' },
    { id: 'scholarshipSession', name: 'Scholarship Session' },
    { id: 'scholarshipAwardDuration', name: 'Scholarship Award Duration' },
    { id: 'courseOfStudy', name: 'Course of Study' },
    { id: 'gender', name: 'Gender' },
    { id: 'bank', name: 'Bank' },
    // { id: 'bankDetail', name: 'Beneficiary Bank Detail' }
  ];

  constructor(
    private countryFacade: CountryFacade,
    private stateFacade: StateFacade,
    private lgaFacade: LgaFacade,
    private scholarshipTypeFacade: ScholarshipTypeFacade,
    private scholarshipCategoryFacade: ScholarshipCategoryFacade,
    private scholarshipSessionFacade: ScholarshipSessionFacade,
    private scholarshipAwardDurationFacade: ScholarshipAwardDurationFacade,
    private communityFacade: CommunityFacade,
    private courseOfStudyFacade: CourseOfStudyFacade,
    private genderFacade: GenderFacade,
    public matDialog: MatDialog,
    private bankFacade: EpimsBankFacade,
    private bankDetailFacade: EpimsBankDetailFacade,
    private currencyFacade: CurrencyFacade
  ) {}

  ngOnInit() {
    this.isLoadingCountry$ = this.countryFacade.isLoadingCountry;
    this.isLoadingState$ = this.stateFacade.isLoadingState;
    this.isLoadingLga$ = this.lgaFacade.isLoadingLga;
    this.isLoadingCommunity$ = this.communityFacade.isLoadingCommunity;
    this.isLoadingCourseOfStudy$ = this.courseOfStudyFacade.isLoadingCourseOfStudy;
    this.isLoadingScholarshipAwardDuration$ = this.scholarshipAwardDurationFacade.isLoadingScholarshipAwardDuration;
    this.isLoadingScholarshipSession$ = this.scholarshipSessionFacade.isLoadingScholarshipSession;
    this.isLoadingScholarshipType$ = this.scholarshipTypeFacade.isLoadingScholarshipType;
    this.isLoadingScholarshipCategory$ = this.scholarshipCategoryFacade.isLoadingScholarshipCategory;
    this.isLoadingGender$ = this.genderFacade.isLoadingGender;
    this.isLoadingBank$ = this.bankFacade.isLoadingEpimsBank;
    this.isLoadingCurrency$ = this.currencyFacade.isLoadingCurrency;
    // this.isLoadingBankDetail$ = this.bankDetailFacade.isLoadingEpimsBankDetail;

    this.country$ = this.countryFacade.loadCountry;
    this.state$ = this.stateFacade.loadState;
    this.lga$ = this.lgaFacade.loadLga;
    this.community$ = this.communityFacade.loadCommunity;
    this.courseOfStudy$ = this.courseOfStudyFacade.loadCourseOfStudy;
    this.scholarshipAwardDuration$ = this.scholarshipAwardDurationFacade.loadScholarshipAwardDuration;
    this.scholarshipType$ = this.scholarshipTypeFacade.loadScholarshipType;
    this.scholarshipSession$ = this.scholarshipSessionFacade.loadScholarshipSession;
    this.scholarshipCategory$ = this.scholarshipCategoryFacade.loadScholarshipCategory;
    this.gender$ = this.genderFacade.loadGender;
    this.bank$ = this.bankFacade.loadEpimsBank;
    this.currency$ = this.currencyFacade.loadCurrency;
    // this.bankDetail$ = this.bankDetailFacade.loadEpimsBankDetail;

    this.sub = this.country$.subscribe((data) => {
      this.countries = data.map((item) => {
        return {
          CountryName: item.CountryName,
          CountryCode: item.CountryCode,
          id: item.id,
        };
      });
    });

    this.sub = this.state$.subscribe((data) => {
      this.states = data.map((item) => {
        return {
          StateName: item.StateName,
          CountryId: item.CountryId,
          id: item.id,
        };
      });
    });

    this.sub = this.lga$.subscribe((data) => {
      this.lgas = data.map((item) => {
        return {
          LgaName: item.LgaName,
          StateId: item.StateId,
          id: item.id,
        };
      });
    });

    this.sub = this.community$.subscribe((data) => {
      this.communities = data.map((item) => {
        return {
          CommunityName: item.CommunityName,
          SerialNo: item.SerialNo,
          LgaId: item.LgaId,
          id: item.id,
        };
      });
    });

    this.sub = this.scholarshipType$.subscribe((data) => {
      this.scholarshipTypes = data.map((item) => {
        return {
          ScholarshipTypeName: item.ScholarshipTypeName,
          ScholarshipCategoryId: item.ScholarshipCategoryId,
          id: item.id,
        };
      });
    });

    this.sub = this.scholarshipCategory$.subscribe((data) => {
      this.scholarshipCategories = data.map((item) => {
        return {
          ScholarshipCategoryName: item.ScholarshipCategoryName,
          id: item.id,
        };
      });
    });

    this.sub = this.scholarshipSession$.subscribe((data) => {
      this.scholarshipSessions = data.map((item) => {
        return {
          ScholarshipSessionName: item.ScholarshipSessionName,
          id: item.id,
        };
      });
    });

    this.sub = this.scholarshipAwardDuration$.subscribe((data) => {
      this.scholarshipAwardDurations = data.map((item) => {
        return {
          ScholarshipAwardDurationName: item.ScholarshipAwardDurationName,
          id: item.id,
        };
      });
    });

    this.sub = this.courseOfStudy$.subscribe((data) => {
      this.courseOfStudies = data.map((item) => {
        return {
          CourseOfStudyName: item.CourseOfStudyName,
          id: item.id,
        };
      });
    });

    this.sub = this.gender$.subscribe((data) => {
      this.genders = data.map((item) => {
        return {
          GenderName: item.GenderName,
          id: item.id,
        };
      });
    });

    this.sub = this.bank$.subscribe((data) => {
      this.banks = data.map((item) => {
        return {
          BankName: item.BankName,
          BankCode: item.BankCode,
          id: item.id,
        };
      });
    });

    // this.sub =	this.bankDetail$.subscribe((data) => {
    // 	this.bankDetails = data.map((item) => {
    // 		return {
    // 			BankName: item.BankName,
    //       SortCode: item.SortCode,
    //       BeneficiaryAccountName: item.BeneficiaryAccountName,
    //       BeneficiaryAccountNumber: item.BeneficiaryAccountNumber,
    //       Branch: item.Branch,
    //       Remark: item.Remark,
    //       BVN: item.BVN,
    // 			id: item.id
    // 		};
    // 	});
    // });

    this.sub = this.currency$.subscribe((data) => {
      this.currencies = data.map((item) => {
        return {
          CurrencyName: item.CurrencyName,
          CurrencyCode: item.CurrencyCode,
          id: item.id,
        };
      });
    });
  }

  selectReference(event) {
    // console.log(event.value);
    this.data = event.value;
    this.task = 'reference';
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDelete(deletedValue: any[]) {
    if (deletedValue[0] === 'country') {
      deletedValue.shift();
      this.countryFacade.removeCountry(deletedValue);
    } else if (deletedValue[0] === 'state') {
      deletedValue.shift();
      this.stateFacade.removeState(deletedValue);
    } else if (deletedValue[0] === 'lga') {
      deletedValue.shift();
      this.lgaFacade.removeLga(deletedValue);
    } else if (deletedValue[0] === 'scholarshipType') {
      deletedValue.shift();
      this.scholarshipTypeFacade.removeScholarshipType(deletedValue);
    } else if (deletedValue[0] === 'scholarshipCategory') {
      deletedValue.shift();
      this.scholarshipCategoryFacade.removeScholarshipCategory(deletedValue);
    } else if (deletedValue[0] === 'scholarshipSession') {
      deletedValue.shift();
      this.scholarshipSessionFacade.removeScholarshipSession(deletedValue);
    } else if (deletedValue[0] === 'scholarshipAwardDuration') {
      deletedValue.shift();
      this.scholarshipAwardDurationFacade.removeScholarshipAwardDuration(
        deletedValue
      );
    } else if (deletedValue[0] === 'courseOfStudy') {
      deletedValue.shift();
      this.courseOfStudyFacade.removeCourseOfStudy(deletedValue);
    } else if (deletedValue[0] === 'community') {
      deletedValue.shift();
      this.communityFacade.removeCommunity(deletedValue);
    } else if (deletedValue[0] === 'gender') {
      deletedValue.shift();
      this.genderFacade.removeGender(deletedValue);
    } else if (deletedValue[0] === 'bank') {
      deletedValue.shift();
      this.bankFacade.removeEpimsBank(deletedValue);
    } else if (deletedValue[0] === 'bankDetail') {
      deletedValue.shift();
      this.bankDetailFacade.removeEpimsBankDetail(deletedValue);
    } else if (deletedValue[0] === 'currency') {
      deletedValue.shift();
      this.currencyFacade.removeCurrency(deletedValue);
    }
  }

  // this method control both the create and update

  onSubmitCountry(formValue: any) {
    if (formValue.type === 'country') {
      event.preventDefault();
      const pullData = formValue.Countries;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllCountry = [];

      // loop through the form data to check for update and create
      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllCountry.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllCountry.length !== 0) {
        this.countryFacade.addCountry(addAllCountry);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.countries, allUpdates);
      if (getChange) {
        // dispatch update data to the store
        this.countryFacade.updateCountry(allUpdates);
      }
    } else if (formValue.type === 'state') {
      event.preventDefault();
      const pullData = formValue.States;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllState = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllState.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllState.length !== 0) {
        this.stateFacade.addState(addAllState);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.states, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.stateFacade.updateState(allUpdates);
      }
    } else if (formValue.type === 'lga') {
      event.preventDefault();
      const pullData = formValue.Lgas;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllLga = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllLga.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllLga.length !== 0) {
        this.lgaFacade.addLga(addAllLga);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.lgas, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.lgaFacade.updateLga(allUpdates);
      }
    } else if (formValue.type === 'community') {
      event.preventDefault();
      const pullData = formValue.Communities;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllCommunity = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllCommunity.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllCommunity.length !== 0) {
        this.communityFacade.addCommunity(addAllCommunity);
      }
      // console.log('communite ', this.communities, allUpdates);
      // check if there is any update on the object
      const getChange = this.getChanges(this.communities, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.communityFacade.updateCommunity(allUpdates);
      }
    } else if (formValue.type === 'courseOfStudy') {
      event.preventDefault();
      const pullData = formValue.CourseOfStudies;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllCourseOfStudy = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllCourseOfStudy.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllCourseOfStudy.length !== 0) {
        this.courseOfStudyFacade.addCourseOfStudy(addAllCourseOfStudy);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.courseOfStudies, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.courseOfStudyFacade.updateCourseOfStudy(allUpdates);
      }
    } else if (formValue.type === 'scholarshipType') {
      event.preventDefault();
      const pullData = formValue.ScholarshipTypes;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllScholarshipType = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllScholarshipType.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllScholarshipType.length !== 0) {
        this.scholarshipTypeFacade.addScholarshipType(addAllScholarshipType);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.scholarshipTypes, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.scholarshipTypeFacade.updateScholarshipType(allUpdates);
      }
    } else if (formValue.type === 'scholarshipCategory') {
      event.preventDefault();
      const pullData = formValue.ScholarshipCategories;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllScholarshipCategory = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllScholarshipCategory.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllScholarshipCategory.length !== 0) {
        this.scholarshipCategoryFacade.addScholarshipCategory(
          addAllScholarshipCategory
        );
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.scholarshipCategories, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.scholarshipCategoryFacade.updateScholarshipCategory(allUpdates);
      }
    } else if (formValue.type === 'scholarshipSession') {
      event.preventDefault();
      const pullData = formValue.ScholarshipSessions;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllScholarshipSession = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllScholarshipSession.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllScholarshipSession.length !== 0) {
        this.scholarshipSessionFacade.addScholarshipSession(
          addAllScholarshipSession
        );
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.scholarshipSessions, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.scholarshipSessionFacade.updateScholarshipSession(allUpdates);
      }
    } else if (formValue.type === 'scholarshipAwardDuration') {
      event.preventDefault();
      const pullData = formValue.ScholarshipAwardDurations;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllScholarshipAwardDuration = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllScholarshipAwardDuration.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllScholarshipAwardDuration.length !== 0) {
        this.scholarshipAwardDurationFacade.addScholarshipAwardDuration(
          addAllScholarshipAwardDuration
        );
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.scholarshipSessions, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.scholarshipAwardDurationFacade.updateScholarshipAwardDuration(
          allUpdates
        );
      }
    } else if (formValue.type === 'gender') {
      event.preventDefault();
      const pullData = formValue.Genders;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllGender = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllGender.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllGender.length !== 0) {
        this.genderFacade.addGender(addAllGender);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.genders, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.genderFacade.updateGender(allUpdates);
      }
    } else if (formValue.type === 'bank') {
      event.preventDefault();
      const pullData = formValue.Banks;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllBank = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllBank.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllBank.length !== 0) {
        this.bankFacade.addEpimsBank(addAllBank);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.banks, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.bankFacade.updateEpimsBank(allUpdates);
      }
    } else if (formValue.type === 'bankDetail') {
      console.log('addddddd', formValue);
      event.preventDefault();
      const pullData = formValue.BankDetails;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllBankDetail = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllBankDetail.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllBankDetail.length !== 0) {
        this.bankDetailFacade.addEpimsBankDetail(addAllBankDetail);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.bankDetails, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.bankDetailFacade.updateEpimsBankDetail(allUpdates);
      }
    } else if (formValue.type === 'currency') {
      event.preventDefault();
      const pullData = formValue.Currencies;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllCurrencies = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllCurrencies.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllCurrencies.length !== 0) {
        this.currencyFacade.addCurrency(addAllCurrencies);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.currencies, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.currencyFacade.updateCurrency(allUpdates);
      }
    }
  }

  getChanges(oldArray, newArray) {
    let changes, i, item, j, len;
    if (JSON.stringify(oldArray) === JSON.stringify(newArray)) {
      return false;
    }
    changes = [];
    for (i = j = 0, len = newArray.length; j < len; i = ++j) {
      item = newArray[i];
      if (JSON.stringify(item) !== JSON.stringify(oldArray[i])) {
        changes.push(item);
      }
    }
    return changes;
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
